// extracted by mini-css-extract-plugin
module.exports = {"header":"_2NNAYRwaZ59lhSX0euLpfa","dialog":"GssAJAfONwnf23vtWJOem"};